module.exports = __webpack_public_path__ + "static/media/RekSai.149dd524.png";